import { Grid, Typography, Box, makeStyles, } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import AveragePriceByChildAge from './AveragePriceByChildAge';
import AveragePriceByNativityOfParents from './AveragePriceByNativityOfParents';
import AveragePriceByRace from './AveragePriceByRace';
import AveragePriceBySettingType from './AveragePriceBySettingType';
import CountyComparisonTable from './CountyComparisonTable';
import CountyContext from '../../contexts/CountyContext';
import CountyMap from './CountyMap';
import Filters from './Filters';
import FiltersContext from '../../contexts/FiltersContext';
import PriceOfChildcareVsPriceOfHousing from './PriceOfChildcareVsPriceOfHousing';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row3() {
  const [familyType, setFamilyType] = useState('All');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const [county, setCounty] = useState(null);
  const [countyCode, setCountyCode] = useState(null);

  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <CountyContext.Provider value={{
        county, setCounty, countyCode, setCountyCode,
      }}
      >
        <SubquestionBox color={lightColor}>
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >

            <Grid item xs={6}>
              <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
                Affordability of care by county
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box displayPrint="none">
                <Filters />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box displayPrint="none">
                <Typography variant="h6" align="center" style={{ textTransform: 'none' }} gutterBottom>
                  Now let&apos;s look at affordability at the county level. Click on a county to see its data.
                </Typography>
              </Box>
              <CountyMap />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ErrorBoundary>
                    <AveragePriceBySettingType height={220} />
                  </ErrorBoundary>
                </Grid>
                <Grid item xs={12}>
                  <ErrorBoundary>
                    <AveragePriceByChildAge height={220} />
                  </ErrorBoundary>
                </Grid>
                <Grid item xs={12}>
                  <ErrorBoundary>
                    <AveragePriceByNativityOfParents height={220} />
                  </ErrorBoundary>
                </Grid>
                <Grid item xs={12}>
                  <ErrorBoundary>
                    <PriceOfChildcareVsPriceOfHousing height={220} />
                  </ErrorBoundary>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <ErrorBoundary>
                <AveragePriceByRace height={220} />
              </ErrorBoundary>
            </Grid>

          </Grid>
          <div className="pagebreak100" />
          <Grid
            container
            spacing={2}
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item xs={12}>
              <ErrorBoundary>
                <CountyComparisonTable />
              </ErrorBoundary>
            </Grid>
          </Grid>

        </SubquestionBox>
      </CountyContext.Provider>
    </FiltersContext.Provider>
  );
}

export default Q1Row3;
